import { render, staticRenderFns } from "./StrokeWidthSlider.ts.vue?vue&type=template&id=d5059012&"
import script from "./StrokeWidthSlider.ts.vue?vue&type=script&lang=ts&"
export * from "./StrokeWidthSlider.ts.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/semaphore/fabric-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d5059012')) {
      api.createRecord('d5059012', component.options)
    } else {
      api.reload('d5059012', component.options)
    }
    module.hot.accept("./StrokeWidthSlider.ts.vue?vue&type=template&id=d5059012&", function () {
      api.rerender('d5059012', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/components/StrokeWidthSlider.ts.vue"
export default component.exports